import React, { useEffect } from 'react'
import utils from '../../utils'
import { FaCheck, FaX } from 'react-icons/fa6'
import moment from 'moment'

function UserTableRow(props) {
    const user = props.user

    useEffect(() => { }, [user])

    const getUserType = (user) => {
        const { is_admin, is_superuser, is_vendor } = user;

        if (is_admin) return 'Admin';
        if (is_superuser) return 'Superuser';
        if (is_vendor) return 'Vendor';
        return 'User';
    };
    return (
        <tr>
            <td className=''>
                <div className="flex gap-3 items-center">
                    <div className="hidden md:avatar placeholder">
                        <div className="bg-neutral text-white rounded-full w-11">
                            <span className="text-lg">{utils.makeProfileLetter(user)}</span>
                        </div>
                    </div>
                    <div>
                        {user?.full_name && (
                            <p className='font-bold'>
                                {user?.full_name}
                            </p>
                        )}
                        <p className='text-gray-600'>
                            {user?.email}
                        </p>
                    </div>
                </div>
            </td>
            <td>
                {getUserType(user)}
            </td>
            <td className='font-bold hidden md:table-cell'>
                {user?.is_verified ? (
                    <FaCheck />
                ) : (
                    <FaX />
                )}
            </td>
            <td className='font-bold hidden md:table-cell'>
                {moment(user?.creation_time).format("MMM Do YYYY")}
            </td>
            <td>
                <button
                    onClick={() => props.openModal(1, user)}
                    className='btn btn-sm btn-primary'>View</button>
            </td>
        </tr>
    )
}

export default UserTableRow